import { render, staticRenderFns } from "./GSDataNewsItem.vue?vue&type=template&id=47bbf691&scoped=true&"
import script from "./GSDataNewsItem.vue?vue&type=script&lang=js&"
export * from "./GSDataNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./GSDataNewsItem.vue?vue&type=style&index=0&id=47bbf691&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbf691",
  null
  
)

export default component.exports